import React from "react";
import {FormattedMessage} from "react-intl";
import PositionChangeIndicator from "../../Ranking/PositionChangeIndicator.jsx";
import {FormattedMoneyHideZero} from "../../utils/FormattedMoneyHideZero";


const SubleagueCell = ({entry, column, onClick}) => {
    switch (column.type) {
        case 'position': {
            let positionDiff = entry.previousPosition ? entry.previousPosition - entry.position : 0;
            return <td className="ranking-entry__position">
                <PositionChangeIndicator className="ranking-entry__diff-icon"
                                         difference={positionDiff}/>
                <strong>{entry.position}</strong>{positionDiff ? ` (${entry.previousPosition})` : null}</td>;
        }

        case 'prize':
            return <td>
                <FormattedMoneyHideZero {...entry.prize}/>
            </td>;

        case 'name':
            return <td>
                <span className="ranking-entry__team-name-wrap">
                {entry.private ?
                    <span className="ranking-entry__private"><FormattedMessage className id="subleagues.private"/><span
                        className="glyphicon glyphicon-lock"/></span> : ''}
                    <button onClick={onClick}
                            className='ranking-entry__team-name'>
                    {entry.name}
                </button>
                    </span>
            </td>;

        case 'points':
            return <td className="ranking-entry__points-total-wrap">
                <span className="ranking-entry__points-total"> {`${entry.points}`}</span>
                {entry.newPoints ? ` (${(entry.newPoints > 0) ? '+' : ''}${entry.newPoints})` : null}
            </td>;

        default:
            return <td>{entry[column.key]}</td>
    }
};

export default SubleagueCell